<style type="text/css">
  :host ::ng-deep .p-button {
    font-size: 30px;
  }
</style>
<div class="wraper">
  <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div class="loaded-content" [class.blurred]="loading">
    <ngfFormData [files]="files"
                 postName="file"
                 [(FormData)]="uploadFormData"></ngfFormData>

        <!-- angular-file uploader  https://www.npmjs.com/package/angular-file-->
        <h1>Upload PCR File</h1>
    <p>Upload a PCR file to generate accession file.</p>
    <hr />
        <p-button ngfSelect
                  multiple="0"
                  type="file"
                  [(files)]="files"
                  [accept]="acceptTypes"
                  (filesChange)="uploadFilesChanged()"
                  icon="far fa-file-csv"
                  label="Browse"
                  style="width:200px; height: 75px; margin-left: 300px">
        </p-button>
        &nbsp;
        <div style="margin-top: 30px; padding-top: 150px; padding-left: 200px; width: 800px; height: 300px; border: dashed 2px darkgray; background-color: white" ngfDrop selectable="1" multiple="0"
             [(files)]="files" (filesChange)="uploadFilesChanged()">
          <h2 style="margin: auto">
            Drop file here to upload
          </h2>

        </div>
      </div>
  </div>
<p-toast>
</p-toast>
